const params = {
  clientId: '5d8e72d223f64_hub',
  clientSecret: '5fe7224812698bbab7ef20fe7262074f85973369',
};

export const enviromentParams = params;
